import 'tether';
import $ from 'jquery';
import bootstrap from 'bootstrap';
import './js/ckeditor-init.js';
import CKEDITOR from 'ckeditor';
import Vue from 'vue';

import vueinst from './js/vue-inst-common.js';

$(document).ready(function(){
	vueinst();
	
	const addCustomEventPolyfill = () => {

	  // source: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent

	  (function() {

	    if (typeof window.CustomEvent !== 'function') {

	      const CustomEvent = (event, params = { bubbles: false, cancelable: false, detail: null }) => {

	        const evt = document.createEvent('CustomEvent');

	        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);

	        return evt;

	      };

	      CustomEvent.prototype = window.Event.prototype;

	      window.CustomEvent = CustomEvent;

	    }

	  })();

	};
	
	addCustomEventPolyfill();
	
	checkConsent();
	
	/**
	 * checks the sourcepoint consent for all configured vendor ids.
	 */
	function checkConsent () {
	  window.consent = window.consent || {};
	  window.dataLayer = window.dataLayer || [];
	  const vendorIds = [
	    "5e71760b69966540e4554f01", // twitter
	    "5e716fc09a0b5040d575080f", // facebook
	    "5ee7add94c24944fdb5c5ac6", // hotjar
	    "5e7e5243b8e05c1c467daa57", // Instagram
	    "5e7ac3fae30e7d1bc1ebf5e8", // youtube
	    "5e839a38b8e05c4e491e738e", // pinterest
	    "5e542b3a4cd8884eb41b5a72", // google analytics
	  ];
	  var pathArray = window.location.pathname.split('/'); 
      if(pathArray.length > 1) {
          if((pathArray[pathArray.length - 2] == "datenschutz" || pathArray[pathArray.length - 2] == "impressum") && pathArray[pathArray.length - 1] == "show.html") {
              return;
          }
      }
      
	  __tcfapi(
	    'getCustomVendorConsents',
	    2,
	    function(data, success) {
	      const layerEvent = {
	        event: 'CmpConsentUpdate'
	      };
	      data.consentedVendors.forEach(function(element) {
	        layerEvent['consent_'+element._id] = true;
	      });
	      window.dataLayer.push(layerEvent);
	      window.consent = layerEvent;
	      window.dispatchEvent(new CustomEvent('CmpConsentUpdate', { detail: layerEvent }));
	    },
	    {
	      data: vendorIds.map(function(e) {
	        return { vendorId: e };
	      }),
	      recheckConsentOnChange: true,
	      perVendor: true
	    }
	  );
	};
	
	window._sp_.addEventListener('onConsentReady', function() {
		checkConsent();
	});
	
	
});



// WEBPACK FOOTER //
// ./src/common.js